import { all, call, put, takeLatest } from 'redux-saga/effects'
import ErrorLogger from 'builder/services/ErrorLogger'
import { apiClient } from 'builder/modules/apiClient'
import { actions } from './billingModule'

export function* fetchYearlyOfferPlanSaga() {
  try {
    const { data } = yield call(apiClient.get, `/payment-plans/yearly-offer`)
    yield put(actions.setYearlyOfferPlan(data.data))
  } catch (error) {
    ErrorLogger.log(error)
  }
}

/** Bind side-effect handlers */
export const sagas = function* saga() {
  yield all([takeLatest(actions.fetchYearlyOfferPlan, fetchYearlyOfferPlanSaga)])
}
